import React from 'react'

const NotFound = () => {
  return (
    <div style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    }}>
        <h1>Error 404</h1>
        <h2 style={{padding: "0px 30px"}}>Page Not Found</h2>
        <a href="/dashboard" style={{fontSize: "15px", fontWeight: "400"}}>Home</a>
    </div>
  )
}

export default NotFound